// utils
import axios from 'axios';

const axiosInstance = axios.create({
  // Do something before request is sent
  baseURL: process.env.REACT_APP_AUTH_URL,
  headers: {
	'Content-Type': 'application/json',
  },
  responseType: 'json'
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
		if(error.response && error.response.status == 401) {
			window.location.assign("/auth/logout");
		}

		return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);

export async function login(username:string,password:string)
{
	return new Promise(async (resolve,reject) => {
		const url = '/auth/signin';

		try {
			const response =  await axiosInstance.post(url, {
				username,
				password,
			});

			resolve(response.data)

		} catch(err){
			reject(err);
		}
	});
}

// export async function register(firstName: string, lastName: string, username:string, 
// 															 email:string, password: string)
// {
// 	return new Promise(async (resolve,reject) => {
// 		const url = '/auth/register';

// 		try {
// 			const response =  await axios.post(url, {
// 				email,
// 				username,
// 				firstName,
// 				lastName,
// 				password,
// 			});

// 			resolve(response.data)

// 		} catch(err){
// 			reject(err);
// 		}
// 	});
// }

export async function resetPassword(username:string)
{
	return new Promise(async (resolve,reject) => {
		const url = '/auth/reset-password';

		try {
			const response =  await axiosInstance.post(url, {username});
			resolve(response.data)
		} catch(err){
			reject(err);
		}
	});
}

export async function newPassword(password: string, username:string, token: string)
{
	return new Promise(async (resolve,reject) => {
		const url = `/auth/reset-password/verify/${username}/${token}`;

		try {
			const response =  await axiosInstance.post(url, {new_password:password, confirmed_password: password});
			resolve(response.data)
		} catch(err){
			reject(err);
		}
	});
}